module.exports = __webpack_public_path__ + "img/goClass.e19b56e5.png";